import React, { useEffect } from "react";
import { Card, Descriptions, Tag, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchInstitution } from "../CompanyProfile/institutionThunk";
import dayjs from "dayjs";
import { Button } from "antd";

const { Title, Text } = Typography;

const getPlanColor = (plan) => {
  switch (plan?.toLowerCase()) {
    case "basic":
      return "default";
    case "standard":
      return "blue";
    case "pro":
      return "green";
    default:
      return "purple";
  }
};

const SubscriptionPage = () => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.institution);

  useEffect(() => {
    dispatch(fetchInstitution());
  }, [dispatch]);

  if (!data) return null;
  console.log(data, "data123");

  const [product, plan] = (data.subscriptionType || "").split("_");

  const expiryDate = data.subscriptionExpiry
    ? dayjs(data.subscriptionExpiry, "DD/MM/YYYY")
    : null;

  const isExpired = expiryDate && expiryDate.isBefore(dayjs());

  return (
    <Card style={{ maxWidth: 800, margin: "20px auto" }}>
      <Title level={4}>Subscription Details</Title>

      <Descriptions column={1} bordered>
        <Descriptions.Item label="Product">
          {product || "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Plan">
          <Tag color={getPlanColor(plan)}>
            {plan || "N/A"}
          </Tag>
        </Descriptions.Item>

        {/* <Descriptions.Item label="Subscription Type">
          {data.subscriptionType || "N/A"}
        </Descriptions.Item> */}

        <Descriptions.Item label="Expiry Date">
          {expiryDate
            ? expiryDate.format("DD MMM YYYY")
            : "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Status">
          <Tag color="green">Active</Tag>
        </Descriptions.Item>
      </Descriptions>

      {/* 🔥 Optional Info */}
      <div style={{ marginTop: 16, textAlign: "center" }}>
        <Text
          type="secondary"
          style={{
            display: "block",
            maxWidth: "100%",
            whiteSpace: "normal",
            overflowWrap: "break-word",
          }}
        >
          Your subscription determines feature access and limits.
        </Text>

        <div style={{ marginTop: 16 }}>
          <Button
            type="primary"
            size="large"
            onClick={() => window.open("https://forthapps.com", "_blank")}
          >
            Manage Subscription
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default SubscriptionPage;